module.exports = __webpack_public_path__ + "static/media/convex_hull_part_2_img_1.66f54ce3.png";